import styled from "styled-components";
import { RAButtonGhost, RATypography } from "@/components/customs";
import { Row, Col } from "antd";
import { SvgArrowStraightRight } from "@/assets/icons";
import { lightTheme } from "@/themes/ThemeConfig";
import { convertVariableCodeToString } from "@/utils";

export function CharterDetailHeader({ type, code, onShowDetails }) {
	return (
		<Container>
			<Row justify="space-between" align="middle" wrap={false}>
				<Col span={14}>
					<Row align="middle" gutter={16}>
						<Col>
							<RequestCodeRow align="middle" wrap={false} gutter={8}>
								<Col>
									<RATypography variant="body4" color={lightTheme.color_text_300}>
										Request Code
									</RATypography>
								</Col>
								<Col>
									<RATypography variant="sub-heading5">{code ?? "_"}</RATypography>
								</Col>
							</RequestCodeRow>
						</Col>
						<Col>
							<RATypography variant="label3" color={lightTheme.color_primary_500}>
								{type ? convertVariableCodeToString(type) : "_"}
							</RATypography>
						</Col>
					</Row>
				</Col>
				<Col>
					<RAButtonGhost
						onClick={onShowDetails}
						title="DETAILS"
						suffix={<SvgArrowStraightRight />}
						data-testid="charterMyBookings_detailsBtn"
					/>
				</Col>
			</Row>
		</Container>
	);
}

const Container = styled.div`
	width: "100%";
	min-height: 52px;
	padding: 0px;
	background: #fafafa;
	border-radius: 12px 12px 0px 0px;
	padding: 0 30px;
	@media (max-width: 768px) {
		padding: 8px 16px;
	}
`;
const RequestCodeRow = styled(Row)`
	border-right: 1px solid #e9e8e8;
	padding: 0 8px 0 0;
	display: flex;
	flex-wrap: nowrap;
	@media (max-width: 576px) {
		border-right: none;
	}
`;
